import { render, staticRenderFns } from "./curriculumList_edit.vue?vue&type=template&id=1e6bf222&scoped=true"
import script from "./curriculumList_edit.vue?vue&type=script&lang=js"
export * from "./curriculumList_edit.vue?vue&type=script&lang=js"
import style0 from "./curriculumList_edit.vue?vue&type=style&index=0&id=1e6bf222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6bf222",
  null
  
)

export default component.exports